<div #container [attr.id]="message.id" class="toast" [class]="message.styleClass || ''" [@messageState]="{
   value: 'visible',
   params: {
     showTransformParams: showTransformOptions,
     hideTransformParams: hideTransformOptions,
     showTransitionParams: showTransitionOptions,
     hideTransitionParams: hideTransitionOptions
   }
 }" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <ng-container *ngIf="!template">
    <div [ngClass]="['toast__icon--' + message.severity, 'toast__icon']">
      <i class="fa-solid" [ngClass]="{
      'fa-check': message.severity === 'info' ||  message.severity === 'success',
      'fa-triangle-exclamation': message.severity == 'warn' || message.severity == 'error'
    }"></i>
    </div>
    <div class=" toast__content" role="alert" aria-live="assertive" aria-atomic="true"
         [ngClass]="message.contentStyleClass || ''">
      <span>{{ message.summary }}</span>
      <p>{{ message.detail }}</p>
    </div>
  </ng-container>
  <ng-container *ngTemplateOutlet="template; context: { $implicit: message }"></ng-container>
  <div class="toast__action-btn" type="button" class="p-toast-icon-close p-link" (click)="onCloseIconClick($event)"
       (keydown.enter)="onCloseIconClick($event)" *ngIf="message.closable !== false" pRipple>
    <i class="fa-regular fa-xmark"></i>
  </div>
</div>
<!--
<div #container [attr.id]="message.id" [class]="message.styleClass || ''"
     [ngClass]="['p-toast-message-' + message.severity, 'p-toast-message']" [@messageState]="{
        value: 'visible',
        params: {
          showTransformParams: showTransformOptions,
          hideTransformParams: hideTransformOptions,
          showTransitionParams: showTransitionOptions,
          hideTransitionParams: hideTransitionOptions
        }
      }" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="p-toast-message-content" role="alert" aria-live="assertive" aria-atomic="true"
       [ngClass]="message.contentStyleClass || ''">
    <ng-container *ngIf="!template">
      <span [class]="'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')" [ngClass]="{
              'pi-info-circle': message.severity == 'info',
              'pi-exclamation-triangle': message.severity == 'warn',
              'pi-times-circle': message.severity == 'error',
              'pi-check': message.severity == 'success'
            }"></span>
      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">{{ message.detail }}</div>
      </div>
    </ng-container>
    <ng-container *ngTemplateOutlet="template; context: { $implicit: message }"></ng-container>
    <button type="button" class="p-toast-icon-close p-link" (click)="onCloseIconClick($event)"
            (keydown.enter)="onCloseIconClick($event)" *ngIf="message.closable !== false" pRipple>
      <span class="fa fa-times"></span>
    </button>
  </div>
</div> -->
